import { post } from 'helpers/api';


export const SET_EDGE_RESEARCH_PROPERTY = 'SET_EDGE_RESEARCH_PROPERTY';
function setEdgeResearchProperty(property) {
  return {
    type: SET_EDGE_RESEARCH_PROPERTY,
    property,
  };
}

function updateEdgeResearchProperty(researchPropertyId) {
  return async (dispatch, getState) => {
    const state = getState();
    const projectId = state.project.id;
    const results = await post(
      `/projects/${projectId}/connect_property`,
      { research_property_id: researchPropertyId }
    );

    dispatch(setEdgeResearchProperty(results.edgeResearchProperty));
  };
}

export function connectResearchProperty(researchPropertyId) {
  return dispatch => dispatch(updateEdgeResearchProperty(researchPropertyId));
}
